import { Settings as SettingsIcon, Database, Archive, Zap } from 'lucide-react';

export default function Settings() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-600">Configure your document management system</p>
      </div>

      {/* General Settings */}
      <div className="card">
        <div className="flex items-center gap-3 mb-4">
          <SettingsIcon className="h-5 w-5 text-gray-600" />
          <h2 className="text-lg font-semibold text-gray-900">General Settings</h2>
        </div>
        <div className="space-y-4">
          <div>
            <label className="label">OpenAI API Key</label>
            <input
              type="password"
              placeholder="sk-..."
              className="input"
              defaultValue="••••••••••••••••"
            />
            <p className="text-xs text-gray-500 mt-1">
              Required for AI document processing
            </p>
          </div>
          <div>
            <label className="label">Currency</label>
            <select className="input">
              <option value="USD">USD - US Dollar</option>
              <option value="EUR">EUR - Euro</option>
              <option value="GBP">GBP - British Pound</option>
            </select>
          </div>
        </div>
      </div>

      {/* Storage Settings */}
      <div className="card">
        <div className="flex items-center gap-3 mb-4">
          <Database className="h-5 w-5 text-gray-600" />
          <h2 className="text-lg font-semibold text-gray-900">Storage Settings</h2>
        </div>
        <div className="space-y-4">
          <div>
            <label className="label">Max File Size (MB)</label>
            <input type="number" defaultValue="50" className="input" />
          </div>
          <div>
            <label className="label">Cloudflare Account ID</label>
            <input
              type="text"
              placeholder="Enter your Cloudflare account ID"
              className="input"
            />
          </div>
        </div>
      </div>

      {/* Archive Settings */}
      <div className="card">
        <div className="flex items-center gap-3 mb-4">
          <Archive className="h-5 w-5 text-gray-600" />
          <h2 className="text-lg font-semibold text-gray-900">Archive Settings</h2>
        </div>
        <div className="space-y-4">
          <div>
            <label className="label">Auto-Archive After (days)</label>
            <input type="number" defaultValue="365" className="input" />
            <p className="text-xs text-gray-500 mt-1">
              Documents older than this will be automatically archived to cheaper storage
            </p>
          </div>
          <button className="btn-primary">Run Archive Now</button>
        </div>
      </div>

      {/* AI Processing */}
      <div className="card">
        <div className="flex items-center gap-3 mb-4">
          <Zap className="h-5 w-5 text-gray-600" />
          <h2 className="text-lg font-semibold text-gray-900">AI Processing</h2>
        </div>
        <div className="space-y-4">
          <label className="flex items-center gap-2">
            <input type="checkbox" defaultChecked className="rounded" />
            <span className="text-sm text-gray-700">
              Enable automatic categorization
            </span>
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" defaultChecked className="rounded" />
            <span className="text-sm text-gray-700">
              Enable duplicate detection
            </span>
          </label>
          <label className="flex items-center gap-2">
            <input type="checkbox" defaultChecked className="rounded" />
            <span className="text-sm text-gray-700">
              Enable OCR for all documents
            </span>
          </label>
        </div>
      </div>

      <div className="flex justify-end gap-4">
        <button className="btn-secondary">Cancel</button>
        <button className="btn-primary">Save Settings</button>
      </div>
    </div>
  );
}

